<template>
	<div class="w-full relative center">
		<div class="relative z-[5] asset-container overscroll-contain w-full" @scroll="handleScroll" ref="scrollEl" :style="{ pointerEvents: images.length > 1 ? 'auto' : 'none' }">
			<div class="assets relative flex w-fit center" :style="{ padding: `0 ${padding}px 0 ${padding}px` }">
				<div class="shrink-0" v-for="x in images" :key="x" :style="{ margin: `0 ${spaceBetween}px 0 ${spaceBetween}px` }">
					<img alt="" :src="`images/1x_images/${x}`" :srcset="`images/2x_images/${x} 2x`" @load="imagesLoaded" />
				</div>
			</div>
		</div>
		<div v-if="images.length > 1" class="relative z-[10] px-[5px] h-[70px] w-fit gap-[90px] bg-[#d7e0f5] rounded-full flex justify-between items-center center will-change-transform" :style="{ top: `${top}px` }">
			<div v-for="x in images.length" :key="x" @click="activate(x)" class="carousel_nav button" :style="{ backgroundColor: active == x ? '#c2ad6c' : '' }">{{ String(x).padStart(2, "0") }}</div>
		</div>
	</div>
</template>

<script>
/* eslint-disable */

export default {
	name: "carousel-1",
	props: {
		images: Array,
		top: "",
		spaceBetween: "",
	},
	data() {
		return {
			active: 1,
			oneScroll: 0,
			padding: 0,
			loaded: 0,
		};
	},
	methods: {
		activate(num) {
			this.$refs.scrollEl.scrollTo({ left: this.oneScroll * (num - 1), behavior: "smooth" });
		},
		handleScroll(e) {
			var scrollAmount = this.$refs.scrollEl.scrollLeft;
			// console.log(scrollAmount);

			var calc1 = scrollAmount / this.oneScroll;
			var calc2 = Math.floor(calc1);
			var calc3 = calc1 - calc2;

			if (calc3 > 0.5) {
				this.active = calc2 + 2;
			} else {
				this.active = calc2 + 1;
			}
		},
		imagesLoaded() {
			this.loaded++;
			if (this.loaded == 1) {
				const img = this.$refs.scrollEl.querySelector("img");
				this.oneScroll = img.offsetWidth;
				this.padding = (1024 - img.offsetWidth) / 2;
			}
			if (this.loaded == this.images.length) {
				this.reset();
			}
		},
		reset() {
			this.active = 1;
			this.$refs.scrollEl.scrollTo({ left: 0, behavior: "instant" });
		},
	},
	mounted() {},
};
</script>

<style scoped>
.carousel_nav {
	font-size: 26px;
	font-style: italic;
	font-weight: 300;
	width: 60px;
	aspect-ratio: 1;
	border-radius: 50%;
	border: 2px solid #c2ad6c;
	display: flex;
	justify-content: center;
	align-items: center;
}
.assets > *:first-child {
	margin-left: 0 !important;
}
.assets > *:last-child {
	margin-right: 0 !important;
}
.asset-container {
	overflow-x: scroll;
	scroll-snap-type: x mandatory;
}
.asset-container > div > div {
	scroll-snap-align: center;
	scroll-snap-stop: always;
}
.asset-container::-webkit-scrollbar {
	display: none;
}
</style>
